import * as PostMessagesActionTypes from './action-types.constants';
import _merge from 'lodash.merge';
import DFP_CONSTANTS from './dfp.constants.json';
function getDefaultState() {
    let DEFAULT_STATE = {
        "ready": false
    }
    const keys = Object.keys(DFP_CONSTANTS);

    keys.forEach( key => {
        DEFAULT_STATE[DFP_CONSTANTS[key]] = null;
    })

    return DEFAULT_STATE;
}

const PostMessages = (state = getDefaultState(), action) => {
    let newState = {};

    const { type } = action;

    switch (type) {
        case PostMessagesActionTypes.INIT:
            newState = Object.assign(getDefaultState(),{ "ready": true});
            break;
        case PostMessagesActionTypes.MESSAGE:
            (() => {
                const { type, config } = action.data;
                if (typeof state[type] !== 'undefined' && state[type] == null) {
                    state[type] = config;
                }
            })();
            break;
        default:
            newState = state;
    }
    if (newState !== state) {
        newState = _merge(getDefaultState(), state, newState);
        //console.log("[PostMessages] New State:",action,"\tstate:",newState);
    }
    return newState;
}

export default PostMessages;